import { Navigate, useLocation } from "react-router-dom";
import { useSupabase } from "../contexts/SupabaseContext";
import {Spinner} from "@asez/component-library";

type ComponentType = React.ComponentType<any>;

const ProtectedRoute = ({
  Component,
  isPublic = false,
  ...props
}: {
  Component: ComponentType;
  isPublic?: boolean;
  [key: string]: any;
}) => {
  const { session, loading } = useSupabase();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[100vh]">
        <Spinner size={32} />
      </div>
    );
  }
  if (isPublic && session) return <Navigate to="/" replace />;
  if (!isPublic && !session)
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  return <Component {...props} />;
};

export default ProtectedRoute;
